<template>
  <header class="site-header">
    <div class="site-header__accent"></div>
    <div class="site-shell site-header__inner">
      <router-link to="/" class="site-brand" aria-label="中国玉雕大师收藏网首页">
        <img :src="$brand.siteLogo" alt="中国玉雕大师收藏网" class="site-brand__logo">
        <span class="site-brand__copy">
          <strong>中国玉雕大师收藏网</strong>
          <small>馆藏档案平台</small>
        </span>
      </router-link>

      <nav class="site-nav" aria-label="主导航">
        <router-link v-for="item in navItems" :key="item.path" :to="item.path" :exact="item.exact" class="site-nav__link">
          {{ item.label }}
        </router-link>
      </nav>

      <router-link to="/certificate" class="site-header__verify">
        <i class="el-icon-search"></i>
        <span>证书查询</span>
      </router-link>

      <button class="site-menu-button" type="button" :aria-expanded="mobileMenuVisible ? 'true' : 'false'" aria-label="打开导航" @click="toggleMobileMenu">
        <span></span><span></span><span></span>
      </button>
    </div>

    <transition name="menu-drop">
      <nav v-show="mobileMenuVisible" class="mobile-nav" aria-label="移动端导航">
        <div class="site-shell mobile-nav__inner">
          <router-link v-for="item in navItems" :key="item.path" :to="item.path" :exact="item.exact" class="mobile-nav__link" @click.native="closeMobileMenu">
            {{ item.label }}
          </router-link>
        </div>
      </nav>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      mobileMenuVisible: false,
      navItems: [
        { path: '/', label: '首页', exact: true },
        { path: '/masters', label: '大师名录' },
        { path: '/gallery', label: '馆藏作品' },
        { path: '/news', label: '馆藏资讯' },
        { path: '/about', label: '平台介绍' }
      ]
    }
  },
  watch: {
    $route() {
      this.closeMobileMenu()
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuVisible = !this.mobileMenuVisible
    },
    closeMobileMenu() {
      this.mobileMenuVisible = false
    }
  }
}
</script>
